// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3RO8J","modalForm":"UpgradeEpcsModal_modalForm__3Sd4p","modalFooter":"UpgradeEpcsModal_modalFooter__C3PfJ"};